export default [
    {
        path: '/ums-demo',
        name: 'UMSDemo',
        component: './Demo',
    }
    , {
        path: '/privacy',
        name: 'Privacy',
        component: './Privacy',
    },
    {
        path: '/user',
        component: '../layouts/BlankLayout',
        routes: [
            {
                path: '/user',
                redirect: '/user/login',
            },
            {
                name: '登录',
                icon: 'smile',
                path: '/user/login',
                component: './user/login',
            },
            {
                component: './exception/404',
            },
        ],
    },
    {
        path: '/',
        component: '../layouts/BasicLayout',
        routes: [

            // 1. 工作台（无渠道划分）
            {
                name: '工作台',
                path: '/workbench',
                access: 'workbench',
                disabledTooltip: true,
                routes: [
                    {
                        path: '/workbench/index',
                        name: '首页',
                        icon: 'icon-zhuye',
                        component: './FirstPage',
                        access: 'home',
                        hideHeader: true,
                    },
                    {
                        name: '质检总览',
                        icon: 'icon-zhijianfenxi',
                        path: '/workbench/stats',
                        component: './data/stats',
                        access: 'qcOverview',
                        hideHeader: true,
                    },
                    {
                        // render fallback 必须放在最后
                        component: './render',
                    },
                ]
            },

            // 2. Agent广场
            {
                name: 'Agent广场',
                path: '/agentHome',
                access: 'agent',
                disabledTooltip: true,
                routes: [
                    {
                        path: '/agentHome/index',
                        name: 'Agent广场',
                        component: './Agent',
                        access: 'agentSquare',
                        icon: 'icon-AIguangchang',
                        hideHeader: true,
                    },
                    {
                        path: '/agentHome/belly',
                        name: 'Belly 助手',
                        component: './Claw',
                        access: 'belly',
                        icon: 'icon-longxiaAI',
                        hideHeader: true,
                    },

                ]
            },

            // 3. 实时风险监控
            {
                name: '实时风险监控',
                path: '/riskMonitor',
                access: 'riskMonitor',
                disabledTooltip: true,
                routes: [
                    {
                        name: '组长实时监控',
                        icon: 'icon-jiankong',
                        path: '/riskMonitor/leaderMonitor',
                        component: './monitor/abnormals',
                        access: 'leaderMonitor',
                        hideHeader: true,
                        tip: '仅有下级的账号可使用'
                    },
                    {
                        name: '实时会话监控',
                        icon: 'icon-huihua',
                        path: '/riskMonitor/dialogMonitor',
                        component: './monitor/customerMonitor',
                        access: 'dialogMonitor',
                        hideHeader: true,
                    },
                    {
                        name: '告警推送',
                        path: '/riskMonitor/alarm',
                        access: '/alarm',
                        hideInMenu: true,
                        hideHeader: true,
                        component: './alarm',
                    },
                    {
                        // render fallback 必须放在最后
                        component: './render',
                    },

                ]
            },

            // 4. 质检管理
            {
                name: '质检管理',
                path: '/qcManage',
                access: 'qcManage',
                disabledTooltip: true,
                routes: [
                    {
                        name: '质检方案',
                        icon: 'icon-zhijianfangan',
                        path: '/qcManage/standard',
                        access: 'qcPlan',
                        routes: [
                            {
                                name: '质检标准',
                                path: '/qcManage/standard/list',
                                component: './standard/list',
                                access: 'qcStandard',
                                hideHeader: true,
                            },
                            {
                                name: '标准修订记录',
                                path: '/qcManage/standard/list/log',
                                component: './standard/log',
                                access: 'qcStandard',
                                hideHeader: true,
                                hideInMenu: true,
                            },
                            {
                                name: '质检项管理',
                                path: '/qcManage/standard/management',
                                component: './standard/management/_layout',
                                access: 'qcItemManage',
                                hideHeader: true,
                            },
                            {
                                name: '编辑规则',
                                path: '/qcManage/standard/list/edit/:id',
                                component: './standard/edit',
                                access: 'qcStandard',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                        ],
                    },
                    {
                        name: '会话原声',
                        icon: 'icon-huihuayuansheng',
                        path: '/qcManage/dialog',
                        access: 'dialogOriginal',
                        routes: [
                            {
                                name: '质检会话列表',
                                path: '/qcManage/dialog/list',
                                component: './dialog/list',
                                access: 'qcDialogList',
                                hideHeader: true,
                            },
                            {
                                name: '历史会话查询',
                                path: '/qcManage/dialog/history',
                                component: './dialog/history',
                                access: 'history',
                                hideHeader: true,
                            },
                            {
                                name: '高级搜索设置',
                                path: '/qcManage/dialog/radar',
                                component: './dialog/radarEntry',
                                access: 'radar',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                            {
                                name: '高级搜索设置',
                                path: '/qcManage/dialog/radar/:id',
                                component: './dialog/radarEntry',
                                access: 'radar',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                        ],
                    },
                    {
                        name: '人工质检',
                        icon: 'icon-rengongzhijian',
                        path: '/qcManage/check',
                        access: 'manualQc',
                        routes: [
                            {
                                name: '人工质检任务列表',
                                path: '/qcManage/check/task',
                                component: './check/task',
                                access: 'manualQcTaskList',
                                hideHeader: true,
                            },
                            {
                                name: '人工质检任务详情',
                                path: '/qcManage/check/task/detail/:id',
                                component: './check/detail',
                                access: 'taskDetail',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                            {
                                name: '人工质检任务记录',
                                path: '/qcManage/check/record',
                                component: './check/record',
                                access: 'manualQcTaskRecord',
                                hideHeader: true,
                            },
                            {
                                name: '质检任务详情',
                                path: '/qcManage/check/record/detail/:id',
                                component: './check/detail',
                                access: 'taskRecordDetail',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                            {
                                // 人工质检诊断报告 - render fallback 必须放在最后
                                component: './render',
                            },
                        ],
                    },
                    {
                        name: '质检申诉',
                        icon: 'icon-zhijianshensu',
                        path: '/qcManage/appeal',
                        access: 'qcAppeal',
                        routes: [
                            {
                                name: '我的申诉',
                                path: '/qcManage/appeal/myself',
                                component: './appeal/myself',
                                access: 'myAppeal',
                                hideHeader: true,
                            },
                            {
                                name: '主管申诉处理',
                                path: '/qcManage/appeal/charge',
                                component: './appeal/charge',
                                access: 'supervisorAppealHandle',
                                hideHeader: true,
                            },
                            {
                                name: '质检员申诉处理',
                                path: '/qcManage/appeal/quality',
                                component: './appeal/quality',
                                access: 'qcStaffAppealHandle',
                                hideHeader: true,
                            },
                            {
                                name: '任务详情',
                                path: '/qcManage/appeal/detail/:id',
                                component: './appeal/detail',
                                access: 'appealDetail',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                        ],
                    },
                    {
                        name: '质培联动',
                        icon: 'icon-zhipeiguanli',
                        path: '/qcManage/train',
                        access: 'qcTrain',
                        routes: [
                            {
                                name: '质培任务分析',
                                path: '/qcManage/train/analyse',
                                component: './data/analyse',
                                access: 'qcTrainTaskAnalyse',
                                hideHeader: true,
                            },
                            {
                                name: '质培任务',
                                path: '/qcManage/train/tasks',
                                component: './train/tasks',
                                access: 'qcTrainTasks',
                                hideHeader: true,
                            },
                            {
                                name: '质培任务详情',
                                path: '/qcManage/train/detail/:id',
                                component: './train/detail',
                                access: 'qcTrainDetail',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                            {
                                name: '会话案例',
                                path: '/qcManage/train/case',
                                component: './case/dialog',
                                access: 'dialogCase',
                                hideHeader: true,
                            },
                            {
                                name: '案例审批中心',
                                path: '/qcManage/train/approve',
                                component: './case/approve',
                                access: 'approveCenter',
                                hideHeader: true,
                            },
                            {
                                name: '案例审批详情',
                                path: '/qcManage/train/approve/detail/:id',
                                component: './case/approve/detail',
                                access: 'approveDetail',
                                hideInMenu: true,
                                hideHeader: true,
                            },
                            {
                                name: '案例标签管理',
                                path: '/qcManage/train/caseLabel',
                                component: './system/caseLabel',
                                access: 'caseLabel',
                                hideHeader: true,
                            },
                            {
                                name: '质培场景标签管理',
                                path: '/qcManage/train/sceneLabel',
                                component: './system/sceneLabel',
                                access: 'sceneLabel',
                                hideHeader: true,
                            },
                        ],
                    },
                ]
            },

            // 5. 报表中心
            {
                name: '报表中心',
                path: '/reportCenter',
                access: 'reportCenter',
                disabledTooltip: true,
                routes: [
                    {
                        name: '质检报表',
                        icon: 'icon-shujuzonglan',
                        path: '/reportCenter/qcReport',
                        access: 'qcReport',
                        routes: [
                            // render fallback 必须放在最后
                            {
                                component: './render',
                            },
                        ],
                    },
                    {
                        path: '/reportCenter/statistics',
                        name: '自定义报表',
                        icon: 'icon-Frame9',
                        component: './report/statistics',
                        access: 'customReport',
                        hideHeader: true,
                    },
                    {
                        // render fallback 必须放在最后
                        component: './render',
                    },
                ]
            },

            // 6. 系统管理
            {
                name: '系统管理',
                path: '/system',
                access: 'system',
                tip: '系统管理不区分平台',
                hidePlatform: true,
                routes: [
                    {
                        name: '店铺管理',
                        icon: 'icon-dianpuguanli',
                        path: '/system/shop',
                        component: './system/shop',
                        access: 'shopManage',
                        tip: '',
                        hideHeader: true,
                    },
                    {
                        name: '子账号管理',
                        icon: 'icon-zizhanghaoguanli',
                        path: '/system/department',
                        component: './system/department',
                        tip: '',
                        access: 'subAccountManage',
                        hideHeader: true,
                    },
                    {
                        name: '人员管理',
                        icon: 'icon-renyuanguanli',
                        path: '/system/snick',
                        tip: '',
                        component: './system/snick',
                        access: 'staffManage',
                        hideHeader: true,
                    },
                    {
                        name: '角色权限管理',
                        icon: 'icon-jiaosequanxianguanli',
                        path: '/system/role',
                        tip: '',
                        component: './system/role',
                        access: 'rolePermissionManage',
                        hideHeader: true,
                    },
                    {
                        name: '组织架构管理',
                        icon: 'icon-zuzhijiagoushezhi',
                        path: '/system/org',
                        component: './system/org',
                        access: 'orgManage',
                        tip: '',
                        hideHeader: true,
                    },
                    {
                        name: '质检效果监控',
                        icon: 'icon-jituanjiankong',
                        path: '/system/effectMonitor',
                        access: 'qcEffectMonitor',
                        tip: '',
                        routes: [

                            {
                                name: '消除识别记录',
                                path: '/system/effectMonitor/eliminateLabels',
                                component: './system/eliminateLabels',
                                access: 'eliminateRecord',
                                tip: '',
                                hideHeader: true,
                            },
                            {
                                // 效果监控 render fallback 必须放在最后
                                component: './render',
                            },
                        ],
                    },
                    // 旧布局- 删除start
                    {
                        name: '案例标签管理',
                        path: '/system/caseLabel',
                        component: './system/caseLabel',
                        hideHeader: true,
                    },
                    {
                        name: '场景标签管理',
                        path: '/system/sceneLabel',
                        component: './system/sceneLabel',
                        hideHeader: true,
                    },
                    {
                        name: '消除识别记录',
                        path: '/system/eliminateLabels',
                        component: './system/eliminateLabels',
                        hideHeader: true,
                    },
                    // 旧布局- 删除end

                ],
            },

            // 产品账号可以看的
            {
                name: '企业管理',
                icon: 'icon-renyuanguanli',
                path: '/company',
                routes: [
                    {
                        path: '/company',
                        redirect: '/company/manage',
                    },
                    {
                        name: '企业管理',
                        icon: 'icontime',
                        path: '/company/manage',
                        component: './company/manage',
                        hideHeader: true,
                    },
                    {
                        name: '店铺管理',
                        path: '/company/shop/:id',
                        component: './company/shop',
                        hideInMenu: true,
                        hideHeader: true,
                    },
                ],
            },
            {
                name: '质检报表',
                icon: 'icon-wenzhang',
                path: '/reportConfig',
                routes: [
                    {
                        path: '/reportConfig',
                        redirect: '/reportConfig/configuration',
                    },
                    {
                        name: '报表配置',
                        path: '/reportConfig/configuration',
                        component: './report/statistics/configPage',
                        hideHeader: true,
                    },
                    {
                        path: '/reportConfig/statistics',
                        name: '自助报表',
                        component: './report/statistics',
                        hideHeader: true,
                    },
                    {
                        path: '/reportConfig/voc',
                        name: 'VOC洞察报表',
                        component: './voc/insight',
                        hideHeader: true,
                    },
                    {
                        path: '/reportConfig/new_bi',
                        name: 'new_bi_报表',
                        component: './report/newBi/insight',
                        hideHeader: true,
                    },
                ],
            },
            {
                name: 'VOC.AI 报表',
                icon: 'icon-wenzhang',
                path: '/voc_ai_reportConfig',
                routes: [
                    {
                        path: '/voc_ai_reportConfig',
                        redirect: '/voc_ai_reportConfig/configuration',
                    },
                    {
                        name: '报表配置',
                        path: '/voc_ai_reportConfig/configuration',
                        component: './report/statisticsVocAi/vocAIConfigPage',
                        hideHeader: true,
                    },
                    {
                        path: '/voc_ai_reportConfig/statistics',
                        name: 'VOC AI数据洞察',
                        component: './report/statisticsVocAi/insight',
                        hideHeader: true,
                    },
                    {
                        path: '/voc_ai_reportConfig/new_statistics',
                        name: 'new_bi_报表',
                        component: './report/newBi/insight',
                        hideHeader: true,
                    },
                ],
            },
            {
                name: '告警推送',
                path: '/alarm',
                access: '/alarm',
                hideInMenu: true,
                hideHeader: true,
                component: './alarm',
            },


            {
                path: '/404',
                component: './exception/404',
            },
            {
                path: '/403',
                component: './exception/403',
            },
        ],

    },

]
